<template>
    <div class="container">
        <button @click="download" class="mt-3 mb-3">Imprimir Etiquets</button>
      <!-- <vue-html2pdf
        :show-layout="true"
        :float-layout="false"
        :enable-download="false"
        :preview-modal="true"
        :paginate-elements-by-height="1400"
        :filename="`Labels-Order-${ticket}`"
        :pdf-quality="2"
        :manual-pagination="false"
        pdf-format="letter"
        :htmlToPdfOptions = "htmlToPdfOptions"
        pdf-orientation="portrait"
        pdf-content-width="100%"
        @progress="onProgress($event)"
        @startPagination="startPagination()"
        @hasPaginated="hasPaginated()"
        ref="html2Pdf"
      >
        <section slot="pdf-content" class="row">
          <div class="container rowsxd">
            <div class="row justify-content-center">
              <div class="labels ml-2 mt-2" v-for="(item, index) in data" :key="index">
                <VueBarcode :value="item.barcode" width="4" :options="barcode_option" >
                  Show this if the rendering fails..
                </VueBarcode>
                <span class=""><b>{{item.key_client}}</b> - {{item.name}} {{item.lastname}} {{item.lastname2}} </span>
                <br />
                <span><b>{{item.key_provider}}</b> - {{item.marca}} - {{item.model}} - {{item.color}} - {{item.numero}} </span>
                <br />
                <span class="endLabels"><b>{{item.sucursal}}</b> - Compra: {{item.date_buy}}</span>
              </div>
            </div>
          </div>
        </section>
      </vue-html2pdf> -->
      <!-- {{data}} -->
      <vue-html2pdf
        :show-layout="true"
        :float-layout="false"
        :enable-download="false"
        :preview-modal="true"
        :paginate-elements-by-height="1000"
        :filename="`Labels-Order`"
        :pdf-quality="2"
        :manual-pagination="true"
        pdf-format="a4"
        :htmlToPdfOptions = "htmlToPdfOptions"
        pdf-orientation="portrait"
        pdf-content-width="100%"
        ref="html2Pdf"
      >
        <section slot="pdf-content">
          <section class="pdf-item labelsComplete">
            <div class="etiqueta col" v-for="(item, index) in data" :key="item.id_order">
              <div v-bind:class="[index > 2 ? 'row justify-content-center mt-2' : 'row justify-content-center']">
                <VueBarcode :value="item.barcode" format="CODE39"  textPosition="top" :options="barcode_option" height="50" width="2" font-size="10"/>
              </div>
              <div class="row justify-content-center printLabels">
                <div class="col-lg-10 text-left pl-3">
                  <p><b>{{item.key_client}}</b> - {{item.name}} {{item.lastname}} {{item.lastname2}} </p>
                  <p><b>{{item.siglas}}</b> - {{item.marca}} - {{item.modelo}} - {{item.color}} - {{item.numero}} </p>
                  <p class="endLabels"><b>{{item.sucursal}}</b>/ {{ item.provider }} /{{item.date_buy}}</p>
                </div>
              </div>
            </div>
          </section>
        </section>
      </vue-html2pdf>
    </div>
</template>
<script>
import axiosAdelaService from '@/axios/axiosAdelaService'
import formatData from '@/mixins/formatAxios'
import VueHtml2pdf from 'vue-html2pdf'
import VueBarcode from 'vue-barcode'
import { mapGetters } from 'vuex'

export default {
  mixins: [formatData],
  components: {
    VueBarcode,
    VueHtml2pdf
  },
  data () {
    return {
      ticket: 0,
      data: [],
      tag: 'svg',
      barcode_option: {
        format: 'EAN13',
        lineColor: '#0aa',
        height: 55
      },
      htmlToPdfOptions: {
        margin: [12, 0, 12, 0],
        filename: 'algo',
        html2canvas: {
          scale: 3,
          useCORS: true
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    })
  },
  methods: {
    async downloadLabels (ticket) {
      const items = {
        ticket: ticket,
        enterprise_id: this.user.enterprise_id
      }
      console.log('getBarcodeInfo', items)
      const response = await axiosAdelaService.post('/getBarcodesforTicket', items)
      console.log('getBarcodeInfo', response)
      if (response.status === 200) {
        this.data = response.data
      }
    },
    async getTicketNumber (orderId) {
      const items = {
        orderId: orderId
      }
      const response = await axiosAdelaService.post('/searchTiketForOrderId', items)
      console.log('searchTiketForOrderId', response)
      if (response.status === 200) {
        await this.downloadLabels(response.data.ticket)
      } else {
        this.$toastedPush({
          message: 'No se pudieron imprimir las etiquetas, por favor, intente desde el reporte de compras',
          type: 'error'
        })
      }
    },
    async download () {
      this.$refs.html2Pdf.generatePdf()
      // window.print()
    },
    onProgress (progress) {
      this.progress = progress
      console.log(`PDF generation progress: ${progress}%`)
    },
    startPagination () {
      console.log('PDF has started pagination')
    },
    hasPaginated () {
      console.log('PDF has been paginated')
    },
    async beforeDownload ({ html2pdf, options, pdfContent }) {
      console.log('On Before PDF Generation')
    },
    hasDownloaded (blobPdf) {
      console.log('PDF has downloaded yehey')
      this.pdfDownloaded = true
      console.log(blobPdf)
    }
  },
  async mounted () {
    console.log('Mounted labels', this.$route.params)
    await this.getTicketNumber(this.$route.params.rows[0].id_order)
    // await this.getTicketNumber(3)
  }
}
</script>
<style>
.labels {
    width: 6.7cm !important;
    height: 2.5cm !important;
    font-size: 7px;
    /* margin-bottom: 20px; */
    vertical-align: top;
    /* margin-left: 25px !important; */
    /* background: yellow; */
    border: solid 1px;
    line-height: 10px;
}
.labels span{
    font-size: 6px;
    line-height: 10px;
}
.endLabels p {
    margin-bottom: 20px !important;
    line-height: 1 !important;
}
.vue-barcode-element {
  width: 100% !important;
  height: 1.4cm !important;
}
.rowsxd {
  /* background: red; */
  width: 100%;
}
.etiqueta {
    width: 76mm !important;
    height: 27.5mm !important;
    /* background: black;s */
    padding: 0px !important;
  }
  .etiqueta svg {

  }
  .labels {
    width: 60mm;
    font-size: 9px;
  }
  .labels p {
    line-height: 1;
    margin: 0;
  }
  .labelsComplete {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  /* grid-auto-rows: minmax(66mm, auto); */
  }
</style>
